import { get } from 'lodash'

import { BenchmarkReport } from './types'

export const reports: BenchmarkReport[] = [
  {
    title: 'Performance Indicators',
    metricCategories: [
      {
        id: 'qps',
        name: 'Query Per Second',
        mainMetrics: [
          {
            name: 'QPS',
            kvs: [
              {
                key: 'Avg',
                value: 'QPS:total#mean'
              },
              {
                key: 'Max',
                value: 'QPS:total#max'
              }
            ]
          }
        ],
        charts: [
          {
            name: 'QPS by SQL types',
            unit: 'qps',
            queries: [
              { promqlId: 'QPS:total', name: 'QPS', type: 'line' },
              { promqlId: 'QPS:by_type', name: '{name}', type: 'bar_stacked' }
            ]
          },
          {
            name: 'QPS by instances',
            unit: 'qps',
            queries: [
              { promqlId: 'QPS:total', name: 'QPS', type: 'line' },
              {
                promqlId: 'QPS:by_instance',
                name: '{name}',
                type: 'bar_stacked'
              }
            ]
          }
        ],
        relatedCharts: [
          {
            name: 'Failed query by instance',
            unit: 'qps',
            queries: [
              { promqlId: 'QPS_failed:total', name: 'QPS_failed', type: 'line' }
            ]
          },
          {
            name: 'CPS by Type',
            unit: 'qps',
            queries: [
              { promqlId: 'CPS:total', name: 'CPS', type: 'line' },
              {
                promqlId: 'CPS:by_type',
                name: '{name}',
                type: 'line'
              }
            ]
          },
          {
            name: 'Queries Using Plan Cache OPS',
            unit: 'qps',
            queries: [
              {
                promqlId: 'Plan_cache_OPS:total',
                name: 'Plan_cache_OPS',
                type: 'line'
              },

              {
                promqlId: 'Plan_cache_miss_OPS:total',
                name: 'Plan_cache_miss_OPS',
                type: 'line'
              }
            ]
          },
          {
            name: 'TPS',
            unit: 'short',
            queries: [
              {
                promqlId: 'TPS:total',
                name: 'TPS',
                type: 'line'
              },
              {
                promqlId: 'Transaction_retry_count:total',
                name: 'Transaction_retry_count',
                type: 'line'
              }
            ]
          }
        ]
      },
      {
        id: 'duration',
        name: 'Query Duration',
        mainMetrics: [
          {
            name: 'Query Duration',
            kvs: [
              { key: 'Avg', value: 'Avg_query_duration:total#mean' },
              { key: 'P90', value: 'P90_query_duration:total#mean' },
              { key: 'P99', value: 'P99_query_duration:total#mean' }
            ]
          }
        ],
        charts: [
          {
            name: 'Query Duration by SQL type',
            unit: 's',
            queries: [
              {
                promqlId: 'Avg_query_duration:by_type',
                name: '{name}',
                type: 'line'
              }
            ]
          },
          {
            name: 'Query Duration by instance',
            unit: 's',
            queries: [
              {
                promqlId: 'Avg_query_duration:by_instance',
                name: '{name}',
                type: 'line'
              }
            ]
          }
        ],
        relatedCharts: [
          {
            name: 'Latency by SQL Phase',
            unit: 's',
            queries: [
              {
                promqlId: 'Avg_get_token_duration:total',
                name: 'Avg_get_token_duration',
                type: 'line'
              },
              {
                promqlId: 'Avg_parse_duration:total',
                name: 'Avg_parse_duration',
                type: 'line'
              },
              {
                promqlId: 'Avg_compile_duration:total',
                name: 'Avg_compile_duration',
                type: 'line'
              },
              {
                promqlId: 'Avg_execute_duration:total',
                name: 'Avg_execute_duration',
                type: 'line'
              }
            ]
          },
          {
            name: 'Latency by SQL Phase + instance',
            unit: 's',
            queries: [
              {
                promqlId: 'Avg_get_token_duration:by_instance',
                name: '{name}_Avg_get_token_duration',
                type: 'line'
              },
              {
                promqlId: 'Avg_parse_duration:by_instance',
                name: '{name}_Avg_parse_duration',
                type: 'line'
              },
              {
                promqlId: 'Avg_compile_duration:by_instance',
                name: '{name}_Avg_compile_duration',
                type: 'line'
              },
              {
                promqlId: 'Avg_execute_duration:by_instance',
                name: '{name}_Avg_execute_duration',
                type: 'line'
              }
            ]
          },
          {
            name: 'Idle connection duration by in/not in txn',
            unit: 's',
            queries: [
              {
                promqlId: 'Avg_idle_connection_duration_in_txn:total',
                name: 'Avg_idle_connection_duration_in_txn',
                type: 'line'
              },
              {
                promqlId: 'Avg_idle_connection_duration_not_in_txn:total',
                name: 'Avg_idle_connection_duration_not_in_txn',
                type: 'line'
              }
            ]
          }
        ]
      },
      {
        id: 'tps',
        name: 'Transaction Per Second',
        mainMetrics: ['TPS:total'],
        charts: [
          {
            name: 'TPS by types + txn modes',
            unit: 's',
            queries: [
              {
                promqlId: 'TPS:total',
                name: 'TPS',
                type: 'line'
              },
              {
                promqlId: 'TPS:by_orthogonality',
                name: 'type: {type}, txn_mode: {txn_mode}',
                type: 'bar_stacked'
              }
            ]
          },
          {
            name: 'TPS by instance',
            unit: 's',
            queries: [
              {
                promqlId: 'TPS:total',
                name: 'TPS',
                type: 'line'
              },
              {
                promqlId: 'TPS:by_instance',
                name: '{name}',
                type: 'bar_stacked'
              }
            ]
          }
        ]
      },
      {
        id: 'txn_duration',
        name: 'Transaction Duration',
        mainMetrics: [
          {
            name: 'Transaction Duration',
            kvs: [
              { key: 'Avg', value: 'Avg_transaction_duration:total#mean' },
              { key: 'P90', value: 'P90_transaction_duration:total#mean' },
              { key: 'P99', value: 'P99_transaction_duration:total#mean' }
            ]
          }
        ],
        charts: [
          {
            name: 'Txn Duration by types + txn modes',
            unit: 's',
            queries: [
              {
                promqlId: 'Avg_transaction_duration:by_orthogonality',
                name: 'type: {type}, txn_mode: {txn_mode}',
                type: 'line'
              }
            ]
          },
          {
            name: 'Txn Duration by instance',
            unit: 's',
            queries: [
              {
                promqlId: 'Avg_transaction_duration:by_instance',
                name: '{name}',
                type: 'line'
              }
            ]
          }
        ]
      },
      {
        id: 'workload',
        name: 'Workload',
        mainMetrics: [
          {
            name: 'Read RPC',
            kvs: [
              {
                key: 'Avg',
                value: 'Read-rpc:total#mean'
              },
              {
                key: 'Max',
                value: 'Read-rpc:total#max'
              }
            ]
          },
          {
            name: 'Write RPC',
            kvs: [
              {
                key: 'Avg',
                value: 'Write-rpc:total#mean'
              },
              {
                key: 'Max',
                value: 'Write-rpc:total#max'
              }
            ]
          },
          {
            name: 'DDL QPS',
            kvs: [
              {
                key: 'Avg',
                value: 'QPS_ddl:total#mean'
              },
              {
                key: 'Max',
                value: 'QPS_ddl:total#max'
              }
            ]
          }
        ],
        charts: [
          {
            name: 'Read RPC by types',
            unit: 'qps',
            queries: [
              {
                promqlId: 'Read-rpc:total',
                name: 'Read OPS',
                type: 'line'
              },
              {
                promqlId: 'Read-rpc:by_type',
                name: '{name}',
                type: 'bar_stacked'
              }
            ]
          },
          {
            name: 'Read RPC by types',
            unit: 'qps',
            queries: [
              {
                promqlId: 'Write-rpc:total',
                name: 'Write OPS',
                type: 'line'
              },
              {
                promqlId: 'Write-rpc:by_type',
                name: '{name}',
                type: 'bar_stacked'
              }
            ]
          },
          {
            name: 'DDL QPS',
            unit: 'qps',
            queries: [
              {
                promqlId: 'QPS_ddl:total',
                name: 'QPS_ddl',
                type: 'line'
              },
              {
                promqlId: 'QPS_ddl:by_type',
                name: '{name}',
                type: 'bar_stacked'
              }
            ]
          }
        ],
        relatedCharts: [
          {
            name: 'Other Workload QPS',
            unit: 'qps',
            queries: [
              {
                promqlId: 'QPS_other:total',
                name: 'QPS_other',
                type: 'line'
              }
            ]
          }
        ]
      },
      {
        id: 'database_time',
        name: 'Database Time',
        mainMetrics: [
          {
            name: 'Database Time',
            kvs: [
              { key: 'Avg', value: 'Database_time:total#mean' },
              { key: 'Max', value: 'Database_time:total#max' }
            ]
          },
          {
            name: 'Database Time by Phase',
            kvs: [
              {
                key: '',
                value: 'Database_time:by_phase#proportion'
              }
            ]
          },
          {
            name: 'Top 3 Database Time by Type',
            kvs: [
              {
                key: '',
                value: 'Database_time:by_type#proportion'
              }
            ]
          }
        ],
        charts: [
          {
            name: 'DataBase Time by SQL types',
            unit: 's',
            queries: [
              {
                promqlId: 'Database_time:total',
                name: 'Database Time',
                type: 'line'
              },
              {
                promqlId: 'Database_time:by_type',
                name: '{name}',
                type: 'bar_stacked'
              }
            ]
          },
          {
            name: 'DataBase Time by SQL Phase',
            unit: 's',
            queries: [
              {
                promqlId: 'Database_time:total',
                name: 'Database Time',
                type: 'line'
              },
              {
                promqlId: 'Get_token_time:total',
                name: 'Get',
                type: 'bar_stacked'
              },
              {
                promqlId: 'Parse_time:total',
                name: 'Parse',
                type: 'bar_stacked'
              },
              {
                promqlId: 'Compile_time:total',
                name: 'Compile',
                type: 'bar_stacked'
              },
              {
                promqlId: 'Execute_time:total',
                name: 'Execute',
                type: 'bar_stacked'
              }
            ]
          }
        ],
        relatedCharts: [
          {
            name: 'DataBase Time by instances',
            unit: 's',
            queries: [
              {
                promqlId: 'Database_time:total',
                name: 'Database Time',
                type: 'line'
              },
              {
                promqlId: 'Database_time:by_instance',
                name: '{name}',
                type: 'bar_stacked'
              }
            ]
          },
          {
            name: 'SQL Execute Time Overview',
            unit: 's',
            queries: [
              {
                promqlId: 'SQL_execute_time:total',
                name: 'Wait_start_TSO_time',
                type: 'bar_stacked'
              },
              {
                promqlId: 'SQL_execute_time:by_type',
                name: '{name}',
                type: 'bar_stacked'
              },
              {
                promqlId: 'Wait_start_TSO_time:total',
                name: 'Wait_start_TSO_time',
                type: 'bar_stacked'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    title: 'Server Resource Check',
    description:
      'If we believe that performance metrics are not meeting expectations, we should identify if there is a bottleneck in resources first.',
    metricCategories: [
      {
        id: 'TiDB_resource',
        name: 'TiDB',
        mainMetrics: [
          'TiDB_uptime:by_instance',
          'TiDB_CPU_usage:by_instance',
          'TiDB_memory_usage:by_instance'
        ],
        charts: [
          {
            name: 'Uptime by instance',
            unit: 's',
            queries: [
              {
                promqlId: 'TiDB_uptime:by_instance',
                name: '{name}',
                type: 'line'
              }
            ]
          },
          {
            name: 'CPU by instance',
            unit: 'percent',
            queries: [
              {
                promqlId: 'TiDB_CPU_usage:by_instance',
                name: '{name}',
                type: 'line'
              }
            ]
          },
          {
            name: 'Memory by instance',
            unit: 'bytes',
            queries: [
              {
                promqlId: 'TiDB_memory_usage:by_instance',
                name: '{name}',
                type: 'line'
              }
            ]
          }
        ],
        relatedCharts: []
      },
      {
        id: 'TiKV_resource',
        name: 'TiKV',
        mainMetrics: [
          'TiKV_uptime:by_instance',
          'TiKV_CPU_usage:by_instance',
          'TiKV_memory_usage:by_instance',
          'TiKV_disk_usage:by_instance',
          'TiKV_IO_read_MBps:by_instance',
          'TiKV_IO_write_MBps:by_instance'
        ],
        charts: [
          {
            name: 'Uptime by instance',
            unit: 's',
            queries: [
              {
                promqlId: 'TiKV_uptime:by_instance',
                name: '{name}',
                type: 'line'
              }
            ]
          },
          {
            name: 'CPU by instance',
            unit: 'percent',
            queries: [
              {
                promqlId: 'TiKV_CPU_usage:by_instance',
                name: '{name}',
                type: 'line'
              }
            ]
          },
          {
            name: 'Memory by instance',
            unit: 'bytes',
            queries: [
              {
                promqlId: 'TiKV_memory_usage:by_instance',
                name: '{name}',
                type: 'line'
              }
            ]
          },
          {
            name: 'Storage by instance & Storage limit',
            unit: 'bytes',
            queries: [
              {
                promqlId: 'TiKV_disk_used:by_instance',
                name: '{name}_used',
                type: 'line'
              },
              {
                promqlId: 'TiKV_disk_capacity:by_instance',
                name: '{name}_capacity',
                type: 'line'
              }
            ]
          },
          {
            name: 'Write IO by instance',
            unit: 'Bps',
            queries: [
              {
                promqlId: 'TiKV_IO_write_MBps:total',
                name: 'Write IO',
                type: 'line'
              },
              {
                promqlId: 'TiKV_IO_write_MBps:by_instance',
                name: '{name}',
                type: 'bar_stacked'
              }
            ]
          },
          {
            name: 'Read IO by instance',
            unit: 'Bps',
            queries: [
              {
                promqlId: 'TiKV_IO_read_MBps:total',
                name: 'Read IO',
                type: 'line'
              },
              {
                promqlId: 'TiKV_IO_read_MBps:by_instance',
                name: '{name}',
                type: 'bar_stacked'
              }
            ]
          }
        ],
        relatedCharts: []
      },
      {
        id: 'TiFlash_resource',
        name: 'TiFlash',
        if: (metrics) => !!get(metrics, 'TiFlash_count:total.values.max'),
        mainMetrics: [
          'TiFlash_uptime:by_instance',
          'TiFlash_CPU_usage:by_instance',
          'TiFlash_memory_usage:by_instance',
          'TiFlash_disk_usage:by_instance',
          'TiFlash_IO_read_MBps:by_instance',
          'TiFlash_IO_write_MBps:by_instance'
        ],
        charts: [
          {
            name: 'Uptime by instance',
            unit: 's',
            queries: [
              {
                promqlId: 'TiFlash_uptime:by_instance',
                name: '{name}',
                type: 'line'
              }
            ]
          },
          {
            name: 'CPU by instance',
            unit: 'percent',
            queries: [
              {
                promqlId: 'TiFlash_CPU_usage:by_instance',
                name: '{name}',
                type: 'line'
              }
            ]
          },
          {
            name: 'Memory by instance',
            unit: 'bytes',
            queries: [
              {
                promqlId: 'TiFlash_memory_usage:by_instance',
                name: '{name}',
                type: 'line'
              }
            ]
          },
          {
            name: 'Storage by instance & Storage limit',
            unit: 'bytes',
            queries: [
              {
                promqlId: 'TiFlash_disk_used:by_instance',
                name: '{name}_used',
                type: 'line'
              },
              {
                promqlId: 'TiFlash_disk_capacity:by_instance',
                name: '{name}_capacity',
                type: 'line'
              }
            ]
          },
          {
            name: 'Write IO by instance',
            unit: 'Bps',
            queries: [
              {
                promqlId: 'TiFlash_IO_write_MBps:total',
                name: 'Write IO',
                type: 'line'
              },
              {
                promqlId: 'TiFlash_IO_write_MBps:by_instance',
                name: '{name}',
                type: 'bar_stacked'
              }
            ]
          },
          {
            name: 'Read IO by instance',
            unit: 'Bps',
            queries: [
              {
                promqlId: 'TiFlash_IO_read_MBps:total',
                name: 'Read IO',
                type: 'line'
              },
              {
                promqlId: 'TiFlash_IO_read_MBps:by_instance',
                name: '{name}',
                type: 'bar_stacked'
              }
            ]
          }
        ],
        relatedCharts: []
      },
      {
        id: 'PD_resource',
        name: 'PD',
        mainMetrics: [
          'PD_uptime:by_instance',
          'PD_CPU_usage:by_instance',
          'PD_memory_usage:by_instance'
        ],
        charts: [
          {
            name: 'Uptime by instance',
            unit: 's',
            queries: [
              {
                promqlId: 'PD_uptime:by_instance',
                name: '{name}',
                type: 'line'
              }
            ]
          },
          {
            name: 'CPU by instance',
            unit: 'percent',
            queries: [
              {
                promqlId: 'PD_CPU_usage:by_instance',
                name: '{name}',
                type: 'line'
              }
            ]
          },
          {
            name: 'Memory by instance',
            unit: 'bytes',
            queries: [
              {
                promqlId: 'PD_memory_usage:by_instance',
                name: '{name}',
                type: 'line'
              }
            ]
          }
        ],
        relatedCharts: []
      }
    ]
  },
  {
    title: 'Latency Bottleneck Breakdown',
    children: [
      {
        title: 'Bottleneck outside of Database',
        description:
          'If everything is fine with the resources, then we need to analyze the latency and understand if the latency is outside the cluster.',
        metricCategories: [
          {
            id: 'active_connection',
            name: 'Active Connection',
            mainMetrics: [
              {
                name: 'Active Connection Count',
                kvs: [
                  {
                    key: 'Avg',
                    value: 'Active_connection_count:total#mean'
                  },
                  {
                    key: 'Max',
                    value: 'Active_connection_count:total#max'
                  }
                ]
              }
            ],
            charts: [
              {
                name: 'Active Connection',
                unit: 'short',
                queries: [
                  {
                    promqlId: 'Active_connection_count:total',
                    name: 'Active_connection_count',
                    type: 'line'
                  }
                ]
              }
            ],
            relatedCharts: []
          },
          {
            id: 'idle_duration',
            name: 'Idle Connection Duration',
            mainMetrics: [
              {
                name: 'Idle Connection Duration in Txn',
                kvs: [
                  {
                    key: 'Avg',
                    value: 'Avg_idle_connection_duration_in_txn:total#mean'
                  },
                  {
                    key: 'P90',
                    value: 'P90_idle_connection_duration_in_txn:total#mean'
                  },
                  {
                    key: 'P99',
                    value: 'P99_idle_connection_duration_in_txn:total#mean'
                  }
                ]
              },
              {
                name: 'Idle Connection Duration not in Txn',
                kvs: [
                  {
                    key: 'Avg',
                    value: 'Avg_idle_connection_duration_not_in_txn:total#mean'
                  },
                  {
                    key: 'P90',
                    value: 'P90_idle_connection_duration_not_in_txn:total#mean'
                  },
                  {
                    key: 'P99',
                    value: 'P99_idle_connection_duration_not_in_txn:total#mean'
                  }
                ]
              }
            ],
            charts: [
              {
                name: 'Idle connection duration',
                unit: 's',
                queries: [
                  {
                    promqlId: 'Avg_idle_connection_duration_in_txn:total',
                    name: 'Avg_idle_connection_duration_in_txn',
                    type: 'line'
                  },
                  {
                    promqlId: 'Avg_idle_connection_duration_not_in_txn:total',
                    name: 'Avg_idle_connection_duration_not_in_txn',
                    type: 'line'
                  }
                ]
              }
            ],
            relatedCharts: [
              {
                name: 'Idle connection duration by in txn',
                unit: 's',
                queries: [
                  {
                    promqlId: 'Avg_idle_connection_duration_in_txn:total',
                    name: 'Avg_idle_connection_duration_in_txn',
                    type: 'line'
                  },
                  {
                    promqlId: 'Avg_idle_connection_duration_not_in_txn:total',
                    name: 'Avg_idle_connection_duration_not_in_txn',
                    type: 'line'
                  }
                ]
              },
              {
                name: 'Idle connection duration by in txn, instance',
                unit: 's',
                queries: [
                  {
                    promqlId: 'Avg_idle_connection_duration_in_txn:by_instance',
                    name: '{name}',
                    type: 'line'
                  }
                ]
              },
              {
                name: 'Latency',
                unit: 's',
                queries: [
                  {
                    promqlId: 'Avg_query_duration:total',
                    name: 'Avg_query_duration',
                    type: 'line'
                  }
                ]
              },
              {
                name: 'Latency by instance',
                unit: 's',
                queries: [
                  {
                    promqlId: 'Avg_query_duration:by_instance',
                    name: '{name}',
                    type: 'line'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        title: 'Bottleneck in Database - General Issues',
        description:
          'After eliminating the above issues, we started to analyze the latency in TiDB. We usually start by checking the different phases of SQL, slow queries, hot regions, indexes, etc.'
      },
      {
        title: 'SQL Phases',
        metricCategories: [
          {
            id: 'database_time_by_sql_phases',
            name: 'Database Time By SQL Phases',
            mainMetrics: [
              'Get_token_time:total',
              'Parse_time:total',
              'Compile_time:total',
              'Execute_time:total'
            ],
            charts: [
              {
                name: 'DataBase Time break down by SQL Phases',
                unit: 's',
                queries: [
                  {
                    promqlId: 'Get_token_time:total',
                    name: 'Get',
                    type: 'line'
                  },
                  {
                    promqlId: 'Parse_time:total',
                    name: 'Parse',
                    type: 'line'
                  },
                  {
                    promqlId: 'Compile_time:total',
                    name: 'Compile',
                    type: 'line'
                  },
                  {
                    promqlId: 'Execute_time:total',
                    name: 'Execute',
                    type: 'line'
                  }
                ]
              }
            ]
          },
          {
            id: 'duration_by_sql_phases',
            name: 'Query Duration by SQL Phases',
            mainMetrics: [
              'Avg_get_token_duration:total',
              'Avg_parse_duration:total',
              'Avg_compile_duration:total',
              'Avg_execute_duration:total'
            ],
            charts: [
              {
                name: 'Query Duration break down by SQL Phases',
                unit: 's',
                queries: [
                  {
                    promqlId: 'Avg_get_token_duration:total',
                    name: 'Avg_get_token_duration',
                    type: 'line'
                  },
                  {
                    promqlId: 'Avg_parse_duration:total',
                    name: 'Avg_parse_duration',
                    type: 'line'
                  },
                  {
                    promqlId: 'Avg_compile_duration:total',
                    name: 'Avg_compile_duration',
                    type: 'line'
                  },
                  {
                    promqlId: 'Avg_execute_duration:total',
                    name: 'Avg_execute_duration',
                    type: 'line'
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },

  {
    title: 'Other',
    metricCategories: [
      {
        id: 'other',
        name: 'Other Advices',
        mainMetrics: [],
        charts: []
      }
    ]
  }
]
